import Modal from './modal'
import duplicate_icon from '../../assets/common/duplicate_icon.webp'
import { styled } from '@linaria/react'
import NiceModal from '@ebay/nice-modal-react'
import { useTranslation } from 'react-i18next'

const Icon = styled.img`
  width: 140px;
  margin-bottom: 16px;
`

const Title = styled.p`
  color: var(--txt);
  font-size: 16px;
  font-family: 'Syncopate-Bold';
  text-transform: uppercase;
  margin-bottom: 20px;
  text-align: center;
  @media (min-width: 1200px) {
    font-size: 18px;
  }
`

const Text = styled.p`
  font-size: 15px;
  color: var(--txt);
  text-align: center;
  font-family: 'Avenir-Light';
  margin-bottom: 12px;
  span {
    font-family: 'Avenir-Heavy';
  }
  @media (min-width: 1200px) {
    font-size: 20px;
  }
`

const Button = styled.button`
  height: 35px;
  border-radius: 10px;
  width: 170px;
  &.secondary {
    margin-top: 12px;
    background-color: #888;
  }
  p {
    font-size: 10px;
    color: #fff;
    font-family: 'Syncopate-Bold';
    text-transform: uppercase;
  }
  @media (min-width: 1200px) {
    width: 190px;
    p {
      font-size: 12px;
    }
  }
`

const DuplicateAccountModal = () => {
  const { t } = useTranslation('duplicateAccount')
  return (
    <Modal id='duplicate-account-modal'>
      <div className='v-flx-ctr'>
        <Icon src={duplicate_icon} alt="Duplicate" />
        <Title>{t('title')}</Title>
        <Text>{t('already-registered')}</Text>
        <Button className="bg-highlight dark:bg-highlight-bg">
          <p>{t('contact')}</p>
        </Button>
        <Button className='secondary'>
          <p>{t('got-it')}</p>
        </Button>
      </div>
    </Modal>
  )
}

export default NiceModal.create(DuplicateAccountModal)